import { StatsProvider, useStats } from './lib/ctx/stats'
import {
  useLoadStats,
  useStatsAnalytics,
  useStatsPermission,
  useStatsUserQuery,
} from './lib/hooks'
import { StatsProfileLoader } from './StatsProfileLoader'
import { StatsProfileError } from './StatsProfileError'
import { CompProps } from '@fable/types'
import { StatsThemeProvider } from './theme/ctx'
import { ReaderSummaryProvider } from './lib/ctx/reader_summary'
import { StatsInitialState } from './lib/ctx/stats/types'

const Content = ({ children }: CompProps) => {
  const status = useStats((s) => s.status)
  const { isPrivate, isStatsOwner } = useStatsPermission()

  const userQuery = useStatsUserQuery()
  useLoadStats()
  useStatsAnalytics()

  if (status === 'loadingYear' || status === 'loading' || userQuery.isLoading) {
    return <StatsProfileLoader />
  }

  if (status === 'error' || isPrivate) {
    const text = isPrivate
      ? "This user's stats have been set to Private."
      : `Sorry, we could not display ${
          isStatsOwner ? 'your' : "this user's"
        } stats.`

    return <StatsProfileError text={text} allowRetry={status === 'error'} />
  }

  return <>{children}</>
}

export const StatsProfileHandler = ({
  children,
  ...props
}: CompProps<StatsInitialState>) => (
  <StatsProvider {...props}>
    <ReaderSummaryProvider>
      <StatsThemeProvider>
        <Content>{children}</Content>
      </StatsThemeProvider>
    </ReaderSummaryProvider>
  </StatsProvider>
)
